var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1995 13.0206C15.2263 11.7369 15.8403 10.1087 15.8403 8.33704C15.8403 4.19301 12.4809 0.833618 8.33692 0.833618C4.19289 0.833618 0.833496 4.19301 0.833496 8.33704C0.833496 12.4811 4.19289 15.8405 8.33692 15.8405C10.1086 15.8405 11.7368 15.2265 13.0205 14.1996L17.7436 18.9228C18.0692 19.2483 18.5971 19.2483 18.9226 18.9228C19.2482 18.5972 19.2482 18.0693 18.9226 17.7437L14.1995 13.0206ZM8.33692 14.1814C5.10917 14.1814 2.49256 11.5648 2.49256 8.33704C2.49256 5.10929 5.10917 2.49268 8.33692 2.49268C11.5647 2.49268 14.1813 5.10929 14.1813 8.33704C14.1813 11.5648 11.5647 14.1814 8.33692 14.1814Z",
    fill: "#3C5873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e23f394f.svg";
export { ForwardRef as ReactComponent };